import { render, staticRenderFns } from "./ContractEditor.vue?vue&type=template&id=8bc39fdc&scoped=true"
import script from "./ContractEditor.vue?vue&type=script&lang=js"
export * from "./ContractEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc39fdc",
  null
  
)

export default component.exports